const isoToDate = (date, defaultValue='') => {
  const value = (new Date(date));
  if(isNaN(value.getTime())) {
    return defaultValue;
  }
  return value;
};

const isoToDateString = (date, defaultValue='') => {
  const value = isoToDate(date, defaultValue);
  if(value instanceof Date) {
    return value.toLocaleDateString("ru-RU");
  }
  return value;
};

export {
  isoToDateString,
  isoToDate
};